import { MIME_FILE_TYPES_EXTENSIONS } from "../Constants/Constants";

function base64ToBlob(base64String: string, mimeType: string) {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

export const DownloadFile = async (fileName: string, fileByte: string, fileType?: string): Promise<void> => {
  try {
    const getFileType: string = fileType ? fileType : MIME_FILE_TYPES_EXTENSIONS['pdf'];
    const blob: Blob = base64ToBlob(fileByte, getFileType);

    // Create a downloadable link
    const downloadLink: HTMLAnchorElement = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);

    // Set the filename for the downloaded PDF file
    downloadLink.download = fileName;

    // Append the link to the document body and trigger the download
    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Clean up the link after download
    document.body.removeChild(downloadLink);
  } catch (error) {
    console.error('Error downloading PDF file:', error);
  }
};